/* eslint-disable @typescript-eslint/no-unused-vars */
import { Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import stockBackground from '../../../assets/stockBackground.png'

import useStyles from './useStyles'

const LeftContainer = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <Grid item lg={4} className={classes.leftColumn}>
      <Grid container className={classes.fullHeightContainer}>
        <Grid item xs={12} className={classes.imageContainer}>
          <Grid container justifyContent={'flex-end'} className={classes.fullHeightContainer}>
            <img src={stockBackground} alt="stock image" className={classes.fullHeightContainer} />
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.quoteGridContainer}>
          <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            className={classes.fullHeightContainer}
          >
            <Grid item xs={9} className={classes.fullHeightContainer}>
              <Grid
                container
                className={classes.quoteGrid}
                flexDirection={'column'}
                flexWrap={'nowrap'}
              >
                <Typography className={classes.leftColumnTypography}>
                  {t<string>('login.leftContainerHeadText')}
                </Typography>
                <Typography className={classes.leftColumnTypographySmall}>
                  {t<string>('login.leftContainerSubText')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default LeftContainer
